exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dialogcamera .camera-button{\n  color: red;\n}\n\n.dialogcamera .content{\n  position: relative;\n  display: flex;\n  height: 100%;\n  align-items: center;\n  overflow: hidden;\n  justify-content: center;\n}\n\n.dialogcamera .change-camera{\n  position: absolute;\n  left: 0;\n  margin-left: 10px;\n}\n", ""]);

